import * as React from 'react';
import { AlreadyPlayedScreenConfiguration } from '../../common-types/ScreensConfigurations.type';
import { Background } from '../common-components/Background';
import { HtmlZone } from '../common-components/HtmlZone';
import { BlockInfoType } from '../../common-types/BlockInfo.type';

interface Props {
  config: AlreadyPlayedScreenConfiguration;
  addEditableBlock?: (block: BlockInfoType) => void;
  isEdition?: boolean;
  onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
}

export const AlreadyPlayedScreen: React.FunctionComponent<Props> = ({ config, addEditableBlock, isEdition, onBlockEdit } : Props) => {
  return (
    <Background
      displayName="Background"
      sizeInfo={{ height: 1200, width: 1200 }}
      addEditableBlock={addEditableBlock}
      dataTemplateConfig="screens.alreadyPlayed.background"
      backgroundImage={config.background.imageUrl}
      backgroundColor={config.background.color}
      isEdition={isEdition}
      onClick={onBlockEdit}
    >
      <HtmlZone
        addEditableBlock={addEditableBlock}
        displayName="HTML Zone"
        dataTemplateConfig="screens.alreadyPlayed.mainTextBox"
        html={config.mainTextBox.html}
        isEdition={isEdition}
        onClick={onBlockEdit}
      />
    </Background>
  );
};
